export const SHIFT_LIST_DEFAULTS: Record<string, string> = {
  search: '',
  page: '1',
};

/** Fixed page size for the Shifts list (no rows-per-page selector — matches Users). */
export const SHIFTS_PAGE_SIZE = 25;
